<template>
  <v-card class="mx-auto mt-3" outlined elevation="7" :class="cardDisabled">
    <!--link's title and url -->
    <div class="d-flex">
      <!-- draggable element -->
      <div class="drag-card pl-0 d-flex flex-column justify-center align-center">
        <div class="icon-card">
          <v-img :src="card.srcIcon || iconDefaulft"></v-img>
        </div>
        <div class="area">...</div>
      </div>
      <!-- card components -->
      <div class="card-outline d-flex flex-column" style="overflow:hidden; width: 350px;">
        <v-list-item-content class="card-content" @click="openLink(card.linkHttps)">
          <v-list-item-title class="pt-1 subtitle-1" hide-details="auto">{{ card.linkTitle }}</v-list-item-title>
          <v-list-item-title
            class="pt-0 body-2"
            hide-details="auto"
            style="text-decoration: underline;"
          >{{ card.linkHttps }}</v-list-item-title>
        </v-list-item-content>
        <div
          class="d-flex justify-space-between align-center"
          style="min-width: 100%; height:40px;"
        >
          <!-- active and desactive link -->
          <div>
            <v-card-actions
              class="d-flex justify-space-between card-outline"
              style="padding-left:0px;"
            >
              <v-switch
                v-model="card.actived"
                class="pr-0"
                @change="$emit('changeactivedlink', card)"
                color="purple darken-4"
              />
            </v-card-actions>
          </div>
          
          <div class="d-flex justify-end">

          <!-- edit Link-->
          <EditLink :card="card" :index="index"
          @edit-link="$emit('edit-link', $event)"
          />

          <!-- remove link -->
          <div>
            <v-btn
              color="purple darken-4"
              icon
              v-if="!confirmeDelete"
              @click="confirmeDelete=true"
              class
              style="outline: none;"
            >
              <v-icon>{{ icons.mdiDelete }}</v-icon>
            </v-btn>

            <v-chip
              close
              color="purple darken-4"
              text-color="white"
              v-else
              @click="deleteLink(card)"
              @click:close="confirmeDelete = false"
              style="outline: none;"
            >
              <span>Remove</span>
            </v-chip>
          </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mdiDelete } from "@mdi/js";
import { analytics } from "@/config/firebaseConfig";
import EditLink from "./PopUp/EditLink";

export default {
  components: { EditLink },
  props: ["card","index"],
  data() {
    return {
      icons: {
        mdiDelete,
      },
      disabled: false,
      confirmeDelete: false,
      iconDefaulft: "./images/icons/link.svg",
    };
  },
  computed: {
    cardDisabled() {
      return {
        disabled: !this.card.actived,
      };
    },
  },
  methods: {
    deleteLink(card) {
      this.$emit("deleteLink", card);
      this.confirmeDelete = false;
    },
    openLink(link) {
      window.open(link, "_blank");
      analytics.logEvent("Card_OpnLink");
    },
  },
};
</script>

<style>
.icon-card {
  width: 50%;
  height: 50%;
}
.line-height {
  height: 20px !important;
  overflow: hidden !important;
}
.disabled {
  background-color: #eeeeee !important;
  transition: all 0.3s ease !important;
}
.disabled > div > div {
  font-weight: lighter !important;
  color: gray !important;
}
.card-outline {
  padding: 0px 8px;
}
.card-content {
  padding: 0px;
  height: 100%;
  width: 100%;
}
.drag-card {
  align-items: flex-end;
  border-right: 1px solid grey;
  width: 50px;
  font: 1.5em sans-serif;
}
.area {
  cursor: pointer;
}

</style>